import React, { useState } from 'react'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DatePicker from '@mui/lab/DatePicker'
import { PickersDay, pickersDayClasses } from '@mui/lab'
import { Box, Icon, Typography } from '@mui/material'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'

const AdxPickerDay = (date, selectedDates, pickersDayProps) => {
  //ALL THE PROPS; date, selectedDates, pickersDayProps;
  //must be included in params above eventhough it is not called below.
  //Removing it will crash the calendar.
  return (
    <PickersDay
      {...pickersDayProps}
      sx={{
        [`&&.${pickersDayClasses.selected}`]: {
          backgroundColor: 'alternate.main',
          color: 'white.main',
          fontWeight: 'bold',
        },
        [`&&.${pickersDayClasses.root}`]: {
          fontSize: '14px',
          borderRadius: 2,
        },
        [`&&.${pickersDayClasses.today}`]: {
          borderWidth: '2px',
          borderColor: 'alternate.main',
        },
        [`&&.${pickersDayClasses.disabled}`]: {
          color: 'light-gray-text-2.main',
        },
      }}
    />
  )
}

const InterviewDatePicker = ({
  currentDate,
  setCurrentDate,
  selectedEvent,
  setSelectedEvent,
  setCurrentWeekStartDate,
}) => {
  const [calendarIsOpen, setCalendarIsOpen] = useState(false)

  const handleDateChange = (date) => {
    const currentDate = date
    const dayOfWeek = currentDate.getDay()
    const startOfWeek = new Date(currentDate)
    startOfWeek.setDate(currentDate.getDate() - dayOfWeek)
    setCurrentWeekStartDate(startOfWeek)
    setCurrentDate(date)
    if (selectedEvent.start && selectedEvent.end) {
      setSelectedEvent((prev) => ({
        date: date,
        start: prev.start,
        end: prev.end,
      }))
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        open={calendarIsOpen}
        onClose={() => setCalendarIsOpen(false)}
        value={currentDate}
        inputFormat="MMM yyyy"
        onChange={handleDateChange}
        renderInput={(params) => (
          <Box
            onClick={() => setCalendarIsOpen((prev) => !prev)}
            sx={{
              cursor: 'pointer',
              height: '35px',
              display: 'flex',
              gap: ' 14px',
              alignItems: 'center',
              paddingX: '14px',
              borderRadius: '3.5px',
              border: calendarIsOpen ? '1px solid #09A3A9' : '1px solid #8A8A8A',
            }}
            ref={params.inputRef}
          >
            <CalendarMonthOutlinedIcon sx={{ color: '#09A3A9' }} />
            <Typography>{params.inputProps.value}</Typography>
            <Icon
              sx={{
                color: calendarIsOpen ? 'alternate.main' : 'light-gray-text.main',
                rotate: calendarIsOpen ? '180deg' : '',
              }}
            >
              expand_more
            </Icon>
          </Box>
        )}
        renderDay={AdxPickerDay}
      />
    </LocalizationProvider>
  )
}

export default InterviewDatePicker
